import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";
import type { InputProps } from "../input-old/input.types";

const classedFormHelperText = classed("text-xs text-grey-600", {
  variants: {
    state: {
      error: "text-error",
      success: "text-success",
    },
    disabled: { true: "text-grey-300" },
  },
});

export const getClassedFormHelperText = withClassName((props: Pick<InputProps, "state" | "disabled">) =>
  classedFormHelperText(props),
);
